( function ( _s ) {
	_s.fn.checkboxRadio = function () {
		return this.each( el => {
			const checkboxRadio = el;
			const _checkboxRadio = _s( el );
			const inputType = el.type;

			_checkboxRadio
				.parent()
				.addClass( `custom-${ inputType }-wrapper d-flex flex-row align-items-center` );

			_checkboxRadio
				.wrap( `<div class="custom-${ inputType }"></div>` )
				.after( '<span class="input-state"></span>' );

			const _customCheckboxRadioWrapper = _checkboxRadio.closest(
				`.custom-${ inputType }-wrapper`
			);

			const setCheckboxValue = () => {
				checkboxRadio.click();
			};

			const setRadioValue = () => {
				checkboxRadio.checked = true;
			};

			_customCheckboxRadioWrapper.on( 'click', e => {
				const target = e.target;
				const _target = _s( target );

				if ( checkboxRadio.disabled || _target.attr( 'type' ) === inputType ) return;

				switch ( inputType ) {
					case 'checkbox':
						/**
						 * If wrapper is a label tag, nothing needs to be done,
						 * the checkbox input will be checked/unchecked without the need to call the setCheckboxValue function
						 */
						if ( ! _customCheckboxRadioWrapper.filter( 'label' ).length )
							setCheckboxValue();
						break;
					case 'radio':
						setRadioValue();
						break;
					default:
				}
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '[type="checkbox"], [type="radio"]' ).checkboxRadio();
	} );
} )( window._s );
